import styled from 'styled-components'

const InputUi = styled.input`
  width: 100%;
  height: 40px;
  border: solid 1px #ebedf0;
  border-radius: 3px;
  color: #5c687e;
  text-indent: 10px;
  font-size: 13px;
  font-family: Inter, Helvetica, Arial, sans-serif;
  outline: none;
  &::placeholder {
    color: #9ba9b4;
  }
`

export default InputUi
